var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "commin_aside" }, [
    _c(
      "div",
      { staticClass: "nav_list" },
      _vm._l(_vm.navList, function(item, index) {
        return _c(
          "div",
          {
            key: "nav" + index,
            staticClass: "nav_item",
            on: {
              click: function($event) {
                return _vm.goAnchor(item.id, index)
              }
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "icon",
                class: { divider: index === _vm.activeIndex }
              },
              [_c("el-divider", { attrs: { direction: "vertical" } })],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "title",
                staticStyle: { cursor: "pointer" },
                style: {
                  color:
                    index === _vm.activeIndex ? "var(--theme-color)" : "#212121"
                }
              },
              [_vm._v(_vm._s(item.name))]
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }